module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"label":"Email","pending":"Waiting for a reply","available":"Email is available","not-available":"Email is not available","not-good":"Email is not valid"},"fr_FR":{"label":"Email","pending":"En attente d\u0027une réponse","available":"Email disponible","not-available":"Email non disponible","not-good":"L\u0027email est invalide"}}')
  delete Component.options._Ctor
}
